const ErrorTypes = {
  TYPE_ERROR: 'TYPE_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
};

export default ErrorTypes;
